import { ReactComponent as NoFilterResultsIconRaw } from "../../../img/trade-history/no-filter-results.svg";
import { Button } from "../../../components/general/Button/Button";

import styled from "@emotion/styled";
import { Spacer } from "../../../components/general/Spacer/Spacer";
import { GlobalStore } from "store/global/GlobalStore";
import { useIsMobile } from "hooks/useDeviceType";
import { Body, Title, buttonCss } from ".";

interface NoFilterResultDisplayProps {
  clearAllFilter: () => void;
}

export const NoFilterResultDisplay = ({ clearAllFilter }: NoFilterResultDisplayProps) => {
  const theme = GlobalStore.useState(s => s.theme);
  const isMobile = useIsMobile();
  return (
    <Container>
      <NoFilterResultsIcon />
      <Spacer height="22px" />
      <Title>Nothing to show here.</Title>
      <Body>
        Hmm we can’t find anything that matches this criteria. Try adjusting your filters.
      </Body>
      <Button
        onClick={clearAllFilter}
        shape="square"
        height={40}
        widthExpand={true}
        text="Clear Filters"
        buttonCss={buttonCss(theme, isMobile)}
      />
    </Container>
  );
};

// Sub-components

const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 300px;
`;

const NoFilterResultsIcon = styled(NoFilterResultsIconRaw)`
  margin: auto;
`;
